<script setup lang="ts">
// Vue
import { computed, watch, onMounted } from "vue";

// Data Providers
import { useBuildingTypes } from "@/dataProviders/BuildingTypes";

// GraphQL
import { useGetBuildingTypesLazyQuery, Country_Enum } from "@/graphql";

// Components
import GraphQLError from "@/features/GraphQLError";

// ///////////////////
// Props
// ///////////////////

const props = defineProps<{
  country: Country_Enum | null;
}>();

// ///////////////////
// Data Providers
// ///////////////////

const buildingTypes = useBuildingTypes();

// ///////////////////
// Variables
// ///////////////////

const queryVariables = computed(() => ({
  country: props.country as Country_Enum,
}));

// ///////////////////
// Query
// ///////////////////

const { result, loading, error, refetch, load } = useGetBuildingTypesLazyQuery(
  props.country ? queryVariables.value : { country: Country_Enum.DENMARK },
  {
    fetchPolicy: "no-cache",
  }
);

// ///////////////////
// Lifecycle
// ///////////////////

onMounted(() => {
  load();
});

// ///////////////////
// Watchers
// ///////////////////

watch(
  () => props.country,
  (newValue) => {
    if (newValue) {
      refetch(queryVariables.value);
    }
  }
);

watch(
  result,
  (newValue) => {
    if (newValue) {
      buildingTypes.mapData(newValue);
    }
  },
  { deep: true }
);

watch(loading, (newLoading) => {
  buildingTypes.setLoading(newLoading);
});
</script>

<template>
  <GraphQLError
    :error="error"
    name="BuildingTypes" />
</template>
